var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0833 22.6459C18.875 22.625 18.625 22.625 18.3958 22.6459C13.4375 22.4792 9.5 18.4167 9.5 13.4167C9.5 8.31252 13.625 4.16669 18.75 4.16669C23.8542 4.16669 28 8.31252 28 13.4167C27.9792 18.4167 24.0417 22.4792 19.0833 22.6459Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1868 8.33331C38.2285 8.33331 41.4785 11.6041 41.4785 15.625C41.4785 19.5625 38.3535 22.7708 34.4577 22.9166C34.291 22.8958 34.1035 22.8958 33.916 22.9166",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 30.3333C3.62435 33.7083 3.62435 39.2083 8.66602 42.5625C14.3952 46.3958 23.791 46.3958 29.5202 42.5625C34.5619 39.1875 34.5619 33.6875 29.5202 30.3333C23.8119 26.5208 14.416 26.5208 8.66602 30.3333Z",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.209 41.6667C39.709 41.3542 41.1256 40.75 42.2923 39.8542C45.5423 37.4167 45.5423 33.3959 42.2923 30.9584C41.1465 30.0834 39.7507 29.5 38.2715 29.1667",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.133d676946c9d1969e1facf6ae422407.svg";
export { ForwardRef as ReactComponent };